<template lang="pug">
  v-container(fluid)
    h1 Amazon Smile
</template>

<script>
export default {};
</script>

<style lang="stylus" scoped></style>
